import React from "react";
import {
  Box,
  Paper,
  Divider,
  Typography,
  Grid,
  Button,
  makeStyles
} from "@material-ui/core";
import { LocationOn } from "@material-ui/icons";
import { LogoIconGGT } from "../Logo";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { formatDate } from "../../utils";
import { APPOINTMENT_STATUSES } from "../../constants";
import { useConsumerAuth } from "../../hooks";
import { useTranslation } from "react-i18next";
import { useStripe } from "@stripe/react-stripe-js";

const useClasses = makeStyles(theme => ({
  locationIcon: {
    color: theme.palette.info.dark
  }
}));

const Covid19TestCard = ({ appointment }) => {
  const { token } = useConsumerAuth();
  const stripe = useStripe();
  const history = useHistory();
  const classes = useClasses();
  const { t } = useTranslation();

  return (
    <Paper data-cy={`appointment-${appointment.appointment_id}`}>
      <Box p={2}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <LogoIconGGT height="20px" />
          </Grid>
          <Grid item xs>
            <Typography variant="h6" component="h3">
              {t("components.covid19_test_card.title")}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item>
            <LocationOn fontSize="small" className={classes.locationIcon} />
          </Grid>
          <Grid item xs>
            <Grid container justify="space-between" spacing={2}>
              <Grid item xs>
                <Grid container spacing={2}>
                  <Grid item xs>
                    <Typography>{appointment.loc_name}</Typography>
                    <Typography>
                      {`${appointment.loc_addr1}${
                        appointment.loc_addr2 ? " " + appointment.loc_addr2 : ""
                      }, ${appointment.loc_city}, ${appointment.loc_st} ${
                        appointment.loc_zip
                      }`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Typography>
                  {moment(appointment.scheduled_dt).format("MMM D YYYY")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container justify="space-between" spacing={2}>
              <Grid item>
                <Typography component="h3" variant="body1">
                  {t("components.covid19_test_card.appointment_id")}
                </Typography>
                <Typography variant="body2">
                  {appointment.appointment_id}
                </Typography>
              </Grid>
              <Grid item>
                <Box textAlign="right">
                  <Typography component="h3" variant="body1">
                    {t("components.covid19_test_card.status")}
                  </Typography>
                  <Typography variant="body2">
                    {appointment.status
                      ? APPOINTMENT_STATUSES[appointment.status] || "Unknown"
                      : appointment.appointment_status
                      ? APPOINTMENT_STATUSES[appointment.appointment_status] ||
                        "Unknown"
                      : ""}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Box mt={1}>
              {appointment.appointment_status === "test_completed" ? (
                <>
                  {appointment.test_status === "lab_result_received" ? (
                    <Button
                      onClick={() =>
                        history.push({
                          pathname: `/r/${token}+${appointment.appointment_id}`
                        })
                      }
                      variant="contained"
                      color="primary"
                    >
                      {t("components.covid19_test_card.result")}
                    </Button>
                  ) : null}
                </>
              ) : appointment.payment_checkout_session &&
              appointment.appointment_status === "pending" ? (
                <Button
                  onClick={() =>
                    stripe.redirectToCheckout({
                      sessionId: appointment.payment_checkout_session
                    })
                  }
                  variant="contained"
                  color="primary"
                >
                  {t("components.covid19_test_card.complete_payment")}
                </Button>
              ) : (
                <Button
                  onClick={() =>
                    history.push({
                      pathname: `/appointment/${
                        appointment.appointment_id
                      }/${formatDate(
                        appointment.dob,
                        "YYYY-MM-DD",
                        "YYYYMMDD"
                      )}`
                    })
                  }
                  variant="contained"
                  color="primary"
                >
                  {t("components.covid19_test_card.confirmation")}
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export { Covid19TestCard };
